//
// Validations
//
(function( $ ) {
  ti.forms = {

    //
    // Initialize validation for a form group
    //
    // Options:
    // elm      | The input container. default "form-group"
    // children | The things we should validate. default "input"
    //
    // Callbacks:
    // onValidationSuccess | called when all the children validate within a group.
    // onError
    //
    groupValidationSetup: function(options){

      //
      // Settings
      var settings = $.extend({
        elm: null,
        target: null,
        outputContainerHTML: "<div class='output-container'></div>",
        onValidationSuccess: function(){}

      }, options);

      //
      // Variables
      var containers = $(settings.elm),
          inputRef,
          groupRef,
          rawOutputHTML,
          processedOutputHTML;

      //
      // Attach an event listener to each input (set globally because we will be appending inputs to the dom)
      $(document).on("change", settings.target, settings, ti.forms.groupValidation);

      //
      // Initialize each form group:
      // Add an output container on each input
      // TODO Assign group id to each form group
      // Assign a ref if to each input
      $.each(containers, function(){

        //
        // Assign an id to the input container
        groupRef = ti.generators.string();
        $(this).attr("data-validation-ref", groupRef);

        //
        // Process each input
        $.each($(this).find(settings.target), function(){

          //
          // Generate an id for this input and assign to self and output
          inputRef = ti.generators.string();
          //
          // Output container
          rawOutputHTML = $.parseHTML(settings.outputContainerHTML);
          processedOutputHTML = $(rawOutputHTML).attr("data-input-ref", inputRef)
            .attr("data-validation-ref", groupRef)
            .attr("data-input-output-ref", inputRef)
            .hide();

          //
          // Assign the ref id to the input
          $(this).attr("data-input-ref", inputRef)
            .attr("data-validation-ref", groupRef)
            // Add the new output container
            .after(processedOutputHTML);

        });

      });

      // Loop over and initialize the validation (add output container, assign id, add listener)
      // On input change, check if both inputs are not empty
      // Validate the values
      // Callback ->

      return this;
    },

    //
    // Validate a group of elements
    //
    // Options:
    // elm      | The input container. default "form-group"
    // children | The things we should validate. default "input"
    //
    // Callbacks:
    // onSuccess
    // onError
    //
    groupValidation: function(options){

      //
      // Settings
      var settings = $.extend({
        elm: ".form-group",
        target: "input"

      }, options.data);

      //
      // Variables
      var validTallyArr = [],
          $this = $(this),
          // The ref id to search with
          refId = $this.data("validation-ref"),
          //
          // Find all the inputs that are in the same form group using data-validation-ref
          friends = $(settings.target + "[data-validation-ref=" + refId + "]");



      // TODO On input change, check if both inputs are not empty
      // TODO Validate the values
      // TODO Callback ->

      //
      // Loop over each related input to check that they all have values
      $.each(friends, function(){

        var $this = $(this),
            trimmedValue = $.trim($this.val()),
            startedToEnterData = trimmedValue.length > 0,
            currentInputRefId = $this.data("inputRef"),
            $myOutputContainer = $("[data-input-output-ref=" + currentInputRefId + "]");

        // Only run validations if they started to enter a name
        if (startedToEnterData) {
          ti.forms.validateElm($this, function(valid, message, data){
            if (!valid) {
              $this.addClass("has-error")
              $myOutputContainer.text(message).fadeIn("fast");
            } else {
              $this.removeClass("has-error")
              $myOutputContainer.text(" ").fadeOut("fast");

              // Add a valid tally
              validTallyArr.push(true)
            };
          });
        };
      });

      return this;
    },

    //
    // Validate a single input
    //
    // Setup:
    // The validator knows what validation should be performed by assigning:
    // data-validate-type | name, email
    //
    validateElm: function(elm, callback){

      // Variables
      var valid,
          message,
          data,
          validationType = elm.data("validationType"),
          trimmedValue = $.trim(elm.val()),
          notNull = trimmedValue.length > 0,
          isNull = !notNull,
          allowNull = elm.data("validationAllowNull");

      // Validation helpers
      var onlyLetterRegex = /^[a-z]+$/i,
          hasNumber = /\d/g;

      // if (true) {
      //
      // }

      switch (validationType) {
        case "email":

          // Validations
          var hasAtSign = trimmedValue.indexOf("@") !== -1,
              hasPeriod = trimmedValue.indexOf(".") !== -1;

          // Valid?
          if (allowNull) {
            isNull = false
            valid = true
          } else {
            valid = notNull && hasAtSign && hasPeriod
          }

          // Build the message
          if (isNull) {
            message = "Email cannot be blank."
          } else if (!valid) {
            message = "Please enter a valid email."
            if (window.location.pathname == "/china") {
              message = "请输入正确形式的邮箱地址"
            }
          }

          // Compile data to return
          data = {
            hasPeriod: hasPeriod,
            hasAtSign: hasAtSign,
            notNull: notNull
          }

          break;
        case "name":

          // Validations
          var hasNumber = hasNumber.test(trimmedValue);

          // Valid?
          if (allowNull) {
            isNull = false
            valid = true
          } else {
            valid = notNull && !hasNumber
          }


          // Build the message
          if (isNull) {
            message = "Name cannot be blank."
          } else if (hasNumber) {
            message = "Names should not contain numbers."
          } else if (!valid) {
            message = "Please enter a valid name."
          }

          // Compile data to return
          data = {
            noNumbers: hasNumber,
            notNull: notNull
          }

          break;

        default:

          // Valid?
          valid = notNull


          // Build the message
          if (isNull) {
            message = elm.data("validation-alias") + " cannot be blank."
          }

          // Compile data to return
          data = {
            notNull: notNull
          }

          break;

      };

      //
      // Closing & prepare to call callback, first we have to make sure it's something we can call
      //
      if (typeof callback === "function") {
        callback(valid, message, data);
      };

    },

    //
    // Validate a form
    //
    validateForm: function(options, callback){


      // Loop over each input in a form and run validateElm

      //
      // Settings
      var settings = $.extend({
        elm: "form",
        target: "input"

      }, options);

      //
      // Variables
      var validTallyArr = [],
          elmsToValidate = $(settings.target, settings.elm),
          totalNumberOfElms = elmsToValidate.length,
          hasCallback = typeof callback === "function";
      //
      // Loop over each form on the page
      $.each(elmsToValidate, function(){

        var $this = $(this),
            currentInputRefId = $this.data("inputRef"),
            $myOutputContainer = $("[data-input-output-ref=" + currentInputRefId + "]");

        ti.forms.validateElm($this, function(valid, message, data){
          if (!valid) {
            $this.addClass("has-error");
            $myOutputContainer.text(message).fadeIn("fast");
          } else {
            validTallyArr.push(true);
            $this.removeClass("has-error");
            $myOutputContainer.text(" ").fadeOut("fast");
          };
        });

      });

      // Check if the number of things we checked match the number of things that are in the arr.
      if (validTallyArr.length === totalNumberOfElms && hasCallback) {
        callback(true);
      } else if (hasCallback) {
        callback(false);
      }
    }
  }
}( jQuery ));
